import React from "react";
import { styled } from "styled-components";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
const StyledWrapper = styled.div`
  cursor: pointer;
`;
const ExpandedSectionToggleWrapper = ({ id, children = void 0 }) => {
  const { toggleSection } = useExpandedSections();
  const _toggleSection = () => toggleSection(id, "configuration");
  return /* @__PURE__ */ React.createElement(StyledWrapper, { title: "show details", onClick: _toggleSection }, children);
};
export default ExpandedSectionToggleWrapper;
